import { render, staticRenderFns } from "./GpTabsNav.vue?vue&type=template&id=3514eade&"
import script from "./GpTabsNav.vue?vue&type=script&lang=js&"
export * from "./GpTabsNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports